module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-small-thumbnails-100x100-5b31fbca784ebf1cc1d74370add04a04.jpg";